import React from 'react';
import './PaymentStatusPopup.css';
import { CheckCircle, XCircle } from 'lucide-react'; // Make sure you have lucide-react installed

const PaymentStatusPopup = ({ type, message, onClose }) => {
  if (!type) return null;  
  
  const isSuccess = type === "success";

  return (
    <div className="payment-popup-overlay">
      <div className="payment-popup-card">
        <div className={`payment-icon ${isSuccess ? "success" : "failed"}`}>
          {isSuccess ? <CheckCircle size={64} /> : <XCircle size={64} />}
        </div>
        <h2>{isSuccess ? "Payment Successful" : "Payment Failed"}</h2>
        <p>{message || (isSuccess
          ? "Your payment has been processed successfully."
          : "There was an issue processing your payment. Please try again.")}</p>
        <button onClick={onClose} className="payment-popup-btn">
          {isSuccess ? "Done" : "Try Again"}
        </button>
      </div>
    </div>
  );
};

export default PaymentStatusPopup;
